import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    prices:{},
    loadingPrice: {}, // Separate loading state per token
    errorPrice: {} // Separate error state per token
  }


export const pricesSlice = createSlice({
    name:'prices',
    initialState,
    reducers: {
        setFetchedPrices: (state, action) => {
            state.prices = action.payload
          },
        setPriceLoading: (state, action) => {
            state.loadingPrice = action.payload
          },
          setPriceError: (state, action) => {
            state.errorPrice = action.payload
          }
      }
})


export const {setFetchedPrices,setPriceLoading,setPriceError} = pricesSlice.actions

export const allPrices = (state)=>state.prices.prices
export const priceLoading = (state)=>state.prices.loadingPrice
export const priceError = (state)=>state.prices.errorPrice
